export const FRONT_IMAGES_PATH = "images"; // name Resource
export const API_ENDPOINT_PATH = "imageapi"; // Part of the query string that is the path
export const INFIPIONT_URL = "https://infopoint.e-queo.online/406/tasks";
export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB

export const UploadDocumentsConstants = {
  createButtonLabel: "Загрузить",
  title: "Загрузка документов",
  addDocumentTitle: "Добавление документа",
  validateSizeError: "Размер файла не может превышать 20MB",
  notificationError: "Формат файла не подходит, выберите другой формат",
  uploadPrompt: "Выберите один из форматов (макс. размер 20mb) .jpg,.png,.pdf (при загрузке PDF для каждой картинки будет создана отдельная уникальная ссылка)",
  dragAndDropPrompt: "Перетащите файл сюда или нажмите для загрузки",
  instructions: `1. Нажми на кнопку "Загрузить" и прикрепи фото/скан первой страницы паспорта РФ и страницы с регистрацией
2. Нажми кнопку "Скопировать ссылки"
3. Вернись на платформу в раздел "Задания" и загрузи скопированную ссылку.`,
};
